var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3182 7.09384V3.31366C18.3182 2.13964 17.7853 1.66504 16.4614 1.66504L13.0975 1.66504C11.7736 1.66504 11.2407 2.13964 11.2407 3.31366V7.08552C11.2407 8.26787 11.7736 8.73414 13.0975 8.73414H16.4614C17.7853 8.74247 18.3182 8.26787 18.3182 7.09384Z",
    fill: "#A9A9A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3182 16.4609V13.097C18.3182 11.7731 17.7853 11.2402 16.4614 11.2402H13.0975C11.7736 11.2402 11.2407 11.7731 11.2407 13.097V16.4609C11.2407 17.7848 11.7736 18.3177 13.0975 18.3177H16.4614C17.7853 18.3177 18.3182 17.7848 18.3182 16.4609Z",
    fill: "#A9A9A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74247 7.09384V3.31366C8.74247 2.13964 8.20958 1.66504 6.88569 1.66504L3.52182 1.66504C2.19793 1.66504 1.66504 2.13964 1.66504 3.31366L1.66504 7.08552C1.66504 8.26787 2.19793 8.73414 3.52182 8.73414H6.88569C8.20958 8.74247 8.74247 8.26787 8.74247 7.09384Z",
    fill: "#A9A9A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74247 16.4609V13.097C8.74247 11.7731 8.20958 11.2402 6.88569 11.2402H3.52182C2.19793 11.2402 1.66504 11.7731 1.66504 13.097L1.66504 16.4609C1.66504 17.7848 2.19793 18.3177 3.52182 18.3177H6.88569C8.20958 18.3177 8.74247 17.7848 8.74247 16.4609Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.87ef22b40d60ea2d50f8883afdbbdd06.svg";
export { ForwardRef as ReactComponent };